import { FC, useState, ChangeEvent, useContext } from "react";
import UserSubmit from "../components/UserSubmit";
import { FetchPlayerData } from "../utils/FetchPlayerData";
import UserContext from "../UserContext";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";


const defaultField = '';

const Login: FC = () => {
    const [ code, setField ] = useState(defaultField);
    const { setUser } = useContext(UserContext);

    const navigate = useNavigate();

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        setField(value);
    };

    const handleSubmit = async () => {
        const user = await FetchPlayerData(code.replace('#', '-'));
        if (user)
        {
            navigate('/edit/' + user.connectCode.code.replace('#', '-'));
            setUser(user);
        }
    };

    return (
        <div className='App-header'>
            <p>input your slippi connect code</p>
            <UserSubmit
                value={ code }
                onChange={ handleChange }
            />
            <button onClick={ handleSubmit }>connect</button>
            <br />
            <Footer />
        </div >
    );
};

export default Login;